import { siteConfig } from "../config/site";
import { SocialLinks } from "./SocialLinks";
import { FormattedText } from "./FormattedText";

export function HeroSection() {
  return (
    <section
      className="mx-auto grid min-h-svh w-full max-w-[1600px] grid-cols-[minmax(0,1.2fr)_minmax(360px,.8fr)] grid-rows-[1fr_auto] gap-x-[clamp(60px,8vw,140px)] gap-y-8 px-[clamp(22px,4.4vw,72px)] pt-[clamp(154px,18svh,230px)] pb-[clamp(64px,10svh,150px)] max-[900px]:grid-cols-1 max-[900px]:grid-rows-[1fr_auto_auto] max-[900px]:gap-y-8 max-[620px]:gap-y-6 max-[620px]:pt-[172px] max-[620px]:pb-8"
      aria-labelledby="hero-title"
    >
      <div className="self-center max-[900px]:self-auto">
        <h1
          id="hero-title"
          itemProp="name"
          className="m-0 flex flex-col text-[clamp(70px,10.5vw,176px)] leading-[.76] font-medium tracking-[-.085em] select-none max-[900px]:text-[clamp(68px,18vw,136px)] max-[620px]:text-[clamp(61px,20vw,98px)]"
        >
          <span className="relative z-10">{siteConfig.name}</span>
          <span
            className="ml-[clamp(28px,7vw,120px)] font-normal outlined-text max-[620px]:ml-[7vw]"
            aria-hidden="true"
          >
            World
          </span>
        </h1>

        {siteConfig.intro && (
          <p
            itemProp="description"
            className="mt-[clamp(42px,6vh,70px)] max-w-[32ch] text-[clamp(17px,1.5vw,22px)] leading-relaxed whitespace-pre-line text-ink/75"
          >
            <FormattedText>{siteConfig.intro}</FormattedText>
          </p>
        )}
      </div>

      <SocialLinks links={siteConfig.socialLinks} />
      <a
        href="#work"
        className="inline-flex min-h-11 items-center gap-3 self-end justify-self-start font-mono text-xs text-accent transition-colors hover:text-ink min-[901px]:col-start-1 min-[901px]:row-start-2"
      >
        A bit of what I do <span aria-hidden="true">↓</span>
      </a>
    </section>
  );
}
